import React, { useState } from 'react';

const TooltipComp = (props) => {
    const [active, setActive] = useState(false);
    const {
        children, content, rightEdgeEltooltip
    } = props;
    const arrowPos = rightEdgeEltooltip ? 'reaction-content-left-arrow-right' : '';

    const showTooltip = () => {
        setActive(true);
    };

    const hideTooltip = () => {
        setActive(false);
    };

    return (
        <div
            className="Tooltip-Wrapper-emoji-reaction"
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            onFocus={showTooltip}
            onBlur={hideTooltip}
        >
            {children}
            {
                active
                    ? (
                        <div
                            className={`Tooltip-Tip-emoji-reaction ${arrowPos}`}
                        >
                            {content}
                        </div>
                    )
                    : null
            }
        </div>
    );
};

export default TooltipComp;
